import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { creMsalConfig } from "./creAuthConfig";
import { syncCreActiveAccount } from "./creAccountUtils";

let msalInstance = null;
let initPromise = null;

export function getCreMsalInstance() {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(creMsalConfig);
  }
  return msalInstance;
}

export async function initializeCreMsal() {
  if (initPromise) return initPromise;

  initPromise = (async () => {
    const instance = getCreMsalInstance();
    await instance.initialize();

    instance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload?.account
      ) {
        instance.setActiveAccount(event.payload.account);
      }
    });

    const response = await instance.handleRedirectPromise();
    if (response?.account) {
      instance.setActiveAccount(response.account);
    }

    await syncCreActiveAccount(instance);
    return instance;
  })();

  return initPromise;
}
